import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Typography from 'components/global/Typography';

import { getOTOPackageList } from 'pages/OTOModules/OTOPackageListSlice';

import * as S from './SavingsCalculator.styles';

const FEATURES_MAPPING = {
	FreePackage: 'basic',
	StarterPackage: 'standard'
};

const CurrentPlanCard = ({ billingPeriod }) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user);
	const otoPackageList = useSelector((state) => state.otoPackageList.otoPackageList);

	useEffect(() => {
		dispatch(getOTOPackageList());
	}, [dispatch]);

	const currentPlan = useMemo(() => {
		return otoPackageList.find((plan) => plan.planName === user.planName);
	}, [otoPackageList, user.planName]);

	const basePrice = billingPeriod === 'yearly' ? currentPlan?.yearlyPrice : currentPlan?.monthlyPrice;

	return (
		<S.CurrentPlanInfoContainer>
			<S.CardHeader>
				<Typography variant="p2" fontWeight="700">
					currentPlanDetails
				</Typography>
			</S.CardHeader>
			<div>
				<S.InfoLine>
					<Typography variant="p3" fontWeight="500">
						planType
					</Typography>
					<Typography variant="p2" fontWeight="700">
						{user.planName}
					</Typography>
				</S.InfoLine>
				<S.InfoLine>
					<Typography variant="p3" fontWeight="500">
						basePriceOfAPlan
					</Typography>
					<Typography variant="p2" fontWeight="700" withCurrency>
						{basePrice}
					</Typography>
				</S.InfoLine>
				<S.InfoLine>
					<Typography variant="p3" fontWeight="500">
						features
					</Typography>
					<Typography variant="p2" fontWeight="700">
						{FEATURES_MAPPING[user.planName]}
					</Typography>
				</S.InfoLine>
			</div>
		</S.CurrentPlanInfoContainer>
	);
};

export default CurrentPlanCard;
